import { createContext, useState, useMemo } from 'react';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import type { BlockerFunction } from 'react-router';

type PromptMessageParams = Parameters<BlockerFunction>[0];
type PromptMessage = (params: PromptMessageParams) => boolean | string | undefined;

type PromptContextValue = {
  setPromptWhen: Dispatch<SetStateAction<boolean>>;
  setPromptMessage: Dispatch<SetStateAction<PromptMessage | null>>;
  promptMessage: PromptMessage | null;
  promptWhen: boolean;
};

const PromptData = createContext<PromptContextValue>({
  setPromptWhen: () => undefined,
  setPromptMessage: () => undefined,
  promptMessage: null,
  promptWhen: false,
});
const PromptContext = ({ children }: { children: ReactNode }) => {
  const [promptWhen, setPromptWhen] = useState(false);
  const [promptMessage, setPromptMessage] = useState<PromptMessage | null>(null);

  const providerMemoised = useMemo(() => {
    return {
      promptWhen,
      promptMessage,
      setPromptMessage,
      setPromptWhen,
    };
  }, [promptWhen, promptMessage]);
  return <PromptData.Provider value={providerMemoised}>{children}</PromptData.Provider>;
};

export { PromptData };
export type { PromptMessage };
export default PromptContext;
